import React from "react"
import { PlusCircle } from "@styled-icons/feather/PlusCircle"
import { RichText as PrismicRichText, RichTextBlock } from "prismic-reactjs"

import { Element, Text, TextProps } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import useBreakpoints from "src/legacy/hooks/useBreakpoints"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  handleInteraction: (isOpen: boolean) => void
  headline: Maybe<RichTextBlock[]>
  isExpandable: Maybe<boolean>
  isOpen: boolean
}

export type ListItemHeadline = OwnProps

interface ListItemTextProps extends Partial<TextProps> {
  as?: "button" | "h3"
}

const ListItemHeadline: React.FC<ListItemHeadline> = ({
  handleInteraction,
  headline,
  isExpandable,
  isOpen,
}): React.ReactElement | null => {
  const { breakpoint } = useBreakpoints()
  const { colors } = useTheme()
  const iconSize = breakpoint === "sm" ? "25" : "40"
  const transform = `${isOpen ? "rotate(135deg)" : "rotate(0)"}`

  const expandableItemProps: ListItemTextProps = {
    as: "button",
    "aria-expanded": isOpen,
    "aria-pressed": isOpen,
    role: "button",
    cursor: "pointer",
    onClick: () => handleInteraction(!isOpen),
  }

  const staticItemProps: ListItemTextProps = {
    as: "h3",
    role: "heading",
    cursor: "default",
  }

  const additionalProps = isExpandable ? expandableItemProps : staticItemProps

  return (
    <Text
      alignItems="center"
      display="flex"
      fontSize={["22", "text.subheader"]}
      justifyContent="space-between"
      lineHeight={["28px", "normal"]}
      px={0}
      textAlign="left"
      variant="subheader"
      width="100%"
      {...additionalProps}
    >
      {headline && PrismicRichText.asText(headline)}
      {isExpandable && (
        <Element
          display="flex"
          style={{ transform }}
          transition="all 0.3s ease"
        >
          <PlusCircle size={iconSize} color={colors.teal} />
        </Element>
      )}
    </Text>
  )
}

export default ListItemHeadline
